import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { MenuItem, Text } from 'components/v4';
import { IconComponent } from 'pages/dashboards/v5/components/IconComponent';
import path from '@/routes/constants';

const PARTNER_SCOPE = 40;
const COMPANY_SCOPE = 20;

const EightByEightMenuItems = ({ darkMode, service }) => {
    const accountScope = useSelector((state) => state.login.requiredScope);

    if (!service?.id || accountScope < COMPANY_SCOPE) {
        return null;
    }

    const isPartnerOrAbove = accountScope >= PARTNER_SCOPE;

    const licencesMode = isPartnerOrAbove ? 'edit' : 'view';

    return (
        <>
            {/* Edit — update the 8x8 platform address (Company+) */}
            {/* <Link
                className="bg-transparent !no-underline hover:text-inherit"
                to={`${path.SERVICES_8X8_AUTH}/${service.id}/edit`}
                state={{ serviceId: service.id }}>
                <MenuItem
                    icon={
                        <IconComponent
                            icon="Edit"
                            color={darkMode ? 'white' : 'black'}
                        />
                    }
                    data-walkthroughid={`/dashboard-services/card/${service.name}/edit`}>
                    <Text marginBottom="0">Edit</Text>
                </MenuItem>
            </Link> */}

            {/* Manage Licences — Partner+ edit, Company view */}
            <Link
                className="bg-transparent !no-underline hover:text-inherit"
                to={`${path.SERVICES_8X8_AUTH}/${service.id}/licences`}
                state={{ mode: licencesMode, serviceId: service.id }}>
                <MenuItem
                    icon={
                        <IconComponent
                            icon="Edit"
                            color={darkMode ? 'white' : 'black'}
                        />
                    }
                    data-walkthroughid={`/dashboard-services/card/${service.name}/manage-licences`}>
                    <Text marginBottom="0">Manage Licences</Text>
                </MenuItem>
            </Link>

            {/* Manage Sites — Company+ */}
            <Link
                className="bg-transparent !no-underline hover:text-inherit"
                to="/managed-sites">
                <MenuItem
                    icon={
                        <IconComponent
                            icon="Edit"
                            color={darkMode ? 'white' : 'black'}
                        />
                    }
                    data-walkthroughid={`/dashboard-services/card/${service.name}/manage-sites`}>
                    <Text marginBottom="0">Manage Sites</Text>
                </MenuItem>
            </Link>

            {/* Access Admin Console — TBD, placeholder only */}
            <MenuItem
                icon={
                    <IconComponent
                        icon="ExternalLink"
                        color={darkMode ? 'white' : 'black'}
                    />
                }
                isDisabled
                data-walkthroughid={`/dashboard-services/card/${service.name}/access-admin-console`}>
                <Text marginBottom="0">Access Admin Console</Text>
            </MenuItem>
        </>
    );
};

export default EightByEightMenuItems;
